<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleMovimenti > 0"
      color="blue lighten-4"
      item-key="movimento.id"
      :headers="headers"
      :items="movimentiSorted"
      :options.sync="options"
      :server-items-length="totaleMovimenti"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
    >
    <template v-slot:top>
      <v-toolbar flat color="blue lighten-4">
        <v-btn icon @click="backClick">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title dark>Dettaglio movimento: {{testataOrdine}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mb-2" @click="onNuovaRiga">Nuova Riga</v-btn>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Confermi cancellazione riga ?</v-card-title>
            <v-card-text>{{dettaglioRiga}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
              <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <dialog-errore :show="dialogErrore" :title="erroreMovimento || 'Errore aggiornamento Movimento'" />
      </v-toolbar>
      <!-- <filtri @ricerca="onRicerca" :idParent="chiaveMovimento && chiaveMovimento.riferimento.id"/> -->
      <filtri
        @ricerca="onRicerca"
        :tipoRef="chiaveMovimento && chiaveMovimento.riferimento.tipo"
        :idParent="chiaveMovimento && chiaveMovimento.riferimento.id"
        :dataRef="chiaveMovimento && chiaveMovimento.riferimento.data"
        :causale="chiaveMovimento && chiaveMovimento.causale"
        :aggiornaFiltri="aggiornaFiltri"
        />
       <!--  :movimenti="movimenti" -->
    </template>
    <template v-slot:[`item.riferimento.data`]="{ item }">
      {{ item.riferimento.data && item.riferimento.data.substring(0, 22) | date }}
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="editItem(item)" v-bind="attrs" v-on="on">mdi-pencil</v-icon>
        </template>
        <span>Modifica il movimento</span>
      </v-tooltip>
<!--       <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="duplicateItem(item)" v-bind="attrs" v-on="on">mdi-content-duplicate</v-icon>
        </template>
        <span>Duplica il movimento</span>
      </v-tooltip> -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small @click="deleteItem(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
        </template>
        <span>Cancella il movimento</span>
      </v-tooltip>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="articoliSelected">
        <v-tabs dense v-model="tab">
          <v-tab key="articoliSimili" class="articoliSelected">Articoli Simili</v-tab>
          <!-- <v-tab key="movimento" class="articoliSelected">Movimento</v-tab> -->
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item key="articoliSimili">
            <articoli-simili :item="item"  @creaMovimenti="creaMovimentiArticoliSimili" />
          </v-tab-item>
        </v-tabs-items>
      </td>
    </template>    
    </v-data-table>
    <speed-dial @comando="onSpeedDialogComando"/>
    <stampa-etichette ref="stampaEtichette" />
  </div>
</template>

<script>
  import { dynamicSortMultiple } from '@/components/helpers.js'
  import DialogErrore from '@/components/dialogErrore'
  import SpeedDial from './speedDialDettaglio.vue'
  import Filtri from './dettaglio_filtri'
  import StampaEtichette from '@/components/etichette/stampaEtichette'

  import moment from 'moment'
  import movimenti from '@/services/movimentiService.js'
  import magazzino from '@/services/magazzinoService.js'
  import prodotti from '@/services/prodottiService.js'
  import configurazioni from '@/services/configurazioniService.js'

  import ArticoliSimili from '../elementi/articoli_simili'

  import _ from 'lodash'
  
  export default {
    components: {
      DialogErrore,
      Filtri,
      SpeedDial,
      StampaEtichette,
      ArticoliSimili
    },
    props: {
      // chiaveMovimento : Object
    },
    data () {
      return {
        totaleMovimenti: 0,
        movimenti: [],
        selected: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Codice', value: 'prodotto.codice', align: 'start'},
          { text: 'Descrizione', value: 'prodotto.descrizione' },
          { text: 'Taglia', value: 'variante1' },
          { text: 'Colore', value: 'variante2' },
          { text: 'Quantità', value: 'quantita' },
          { text: 'Valore', value: 'valore' },
          { text: 'Prezzo Unitario', value: 'prodotto.prezzo' },
          { text: 'Prezzo Listino', value: 'prodotto.prezzo2' },
          { text: 'Acquisto', value: 'prodotto.acquisto' }, // TODO: Verificare se specificare il prezzo di acquisto attuale o quello al momento del movimento. Nel caso va aggiunto nel movimento
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        expanded: [],
        singleExpand: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        modelloMovimento: null,
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        // impostazioniEtichette: null,
        usaQtaAnagrafica: false, // TODO: da configurazioni
        salta: 0,
        filtroElementi: null,
        tipoStampa: '',
        report: '',
        erroreMovimento: '',
        aggiornaFiltri: 0
        // isModuloA4: false
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuova riga' : 'Modifica riga'
      },
      movimentiSaved() {
        return this.$store.getters['movimenti/saved']
      },
      refreshList() { // Verificare
        return this.$store.getters['movimenti/refreshDettaglio']
      },
      movimentiSorted() {
        const els = this.movimenti
        const elSorted = els.sort(dynamicSortMultiple('_id'))
        return elSorted
      },
      totaleEtichette() {
        const elSel = this.selected
        if (elSel.length > 0) {
          const totaleAnagrafica = _.uniq(elSel.map(x => x.prodotto.id)).length
          const totaleMovimenti = _.sum(elSel.map(x => x.quantita))
          return { totaleAnagrafica, totaleMovimenti }
        } else {
          return { totaleAnagrafica: 0, totaleMovimenti: 0 }
        }
      },
      testataOrdine() {
        // TODO: Inserire descrizione movimento invece di codice...
        const riferimento = _.get(this,'chiaveMovimento.riferimento.tipo', '') + ': ' + _.get(this,'chiaveMovimento.riferimento.id', '')
        return this.chiaveMovimento ? `${this.chiaveMovimento.causale} - ${moment(this.chiaveMovimento.data).format('DD/MM/YYYY')} - ${this.chiaveMovimento.c_nominativo || riferimento }` : ''
      },
      dettaglioAperto() {
        return this.$store.getters['movimenti/page'] === 'dettaglio'
      },
      chiaveMovimento() {
        return this.$store.getters['movimenti/chiave']
      },
      dettaglioRiga() {
        let ed = this.editedItem
        if (!ed || !ed.prodotto || !ed.prodotto.variante1 || !ed.prodotto.variante2) return ''
        return `${ed.prodotto.descrizione } ${ed.prodotto.variante1.descrizione} ${ed.prodotto.variante2.descrizione}` 
      }      
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      async movimentiSaved(value) {
        if (value && this.dettaglioAperto) {
          await this.save()
        }
      },
      async refreshList(value) {
        if (value) {
          await this.getDataFromApi()
          this.$store.commit('movimenti/CLEAR_REFRESH', 'dettaglio')
        }
      },
      chiaveMovimento(value) {
        // console.log(value)
      }
    },
    async created() {
      this.modelloMovimento = await movimenti.getModello('xxx') // devo tenere una copia pulita
      this.defaultItem = this.modelloMovimento
      this.pathEtichettePrefix = window.appConfig.VUE_APP_MOL_API_GATEWAY || ''
    },
    async mounted () {
      // await this.getDataFromApi()
      // this.impostazioniEtichette = await configurazioni.getConfigurazione('display_generale', 'etichette')
    },
    methods: {
      backClick() {
        this.$emit('back')
      },
      async onRicerca(filtri) {
        this.filtri = filtri
        await this.getDataFromApi()
      },
      async getDataFromApi () {
        try {
          if (this.loading) return
          if (!this.filtri.id) return
          this.loading = true
          /*
            Versione per dettaglio riga 
            const data = await magazzino.getFilteredMovements(this.filtri, this.options)
            this.movimentiRaw = data && data.total_rows > 0 ? data.rows : [] // TODO: valida per la versione modificata. Da adeguare
          */
          // console.log(this.filtri)
          const data = await magazzino.getFilteredDetailMovements(this.filtri, this.options)
        
          // const data = await movimenti.getFilteredMovementHeaders(this.filtri, this.options)
          // this.movimentiRaw = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
/*           this.movimentiRaw = data && data.total_rows > 0 ? data.rows : []
          this.movimenti = this.datiVisualizzazione(this.movimentiRaw) */
          this.movimenti = data && data.total_rows > 0 ? data.rows : []
          this.totaleMovimenti = data.total_rows
          this.aggiornaFiltri++
        } catch(err) {
          this.movimenti = []
          this.totaleMovimenti = 0
        } finally {
          this.loading = false
        }
      },
      async popolaModelloDaChiave() {
        let mc = {
          data: this.chiaveMovimento.data,
          magazzino: this.chiaveMovimento.magazzino,
          causale: this.chiaveMovimento.causale,
          anagrafica: this.chiaveMovimento.anagrafica,
          riferimento: this.chiaveMovimento.riferimento,
          segno: this.chiaveMovimento.segno,
          tipo: this.chiaveMovimento.tipo,
          tipoPrezzo: this.chiaveMovimento.tipoPrezzo
        }
        const causali = await configurazioni.getConfigurazione('magazzino_causali', 'causali')
        const causale = causali.find(x => x.codice === this.chiaveMovimento.causale)
        mc.appoggio = { causale }
        mc.appoggio.clienteVisibile = causale.visualizzaCliente
        mc.appoggio.fornitoreVisibile = causale.visualizzaFornitore
        return mc
      },
      async creaMovimentiArticoliSimili(item, elencoProdotti) {
        const testata = await this.popolaModelloDaChiave()
        let numErrori = 0
        for (let pr of elencoProdotti) {
          const movimento = JSON.parse(JSON.stringify(this.modelloMovimento))
          _.merge(movimento, testata)

          movimento.prodotto.codice = pr._id
          movimento.quantita = +parseFloat(pr.quantita).toFixed(2)
          let prezzo = testata.appoggio.causale.tipoPrezzo === 'acquisto' ? pr.acquisto : pr.vendita
          movimento.valore = +parseFloat(movimento.quantita * prezzo).toFixed(2)
          if (!await magazzino.creaMovimenti(movimento)) {
            numErrori++
          }
        }
        await this.getDataFromApi()
        if (numErrori > 0) {
          this.erroreMovimento = 'Creazione movimenti'
          this.dialogErrore = true
        }
      },
      async onNuovaRiga() {
        this.editedIndex = -1
        this.editedItem = JSON.parse(JSON.stringify(this.modelloMovimento))
        const testata = await this.popolaModelloDaChiave()
        _.merge(this.editedItem, testata)
        this.$store.commit('movimenti/SET_MOVIMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      async editItem (item) {
        this.editedIndex = this.movimenti.indexOf(item)
        this.editedItem = await magazzino.getMovimento(item.movimento.id)
        const testata = await this.popolaModelloDaChiave()
        this.editedItem.appoggio.causale = testata.appoggio.causale
        this.completaAppoggio()
        this.$store.commit('movimenti/SET_MOVIMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      completaAppoggio() {
        let itm = this.editedItem
        itm.appoggio.clienteVisibile = itm.appoggio.causale.visualizzaCliente
        itm.appoggio.fornitoreVisibile = itm.appoggio.causale.visualizzaFornitore
        itm.appoggio.valoreCalcolato = itm.valore
        itm.appoggio.prodotto.acquisto = itm.appoggio.prodotto.magazzino.prezzoAcquisto || 0
        itm.appoggio.prodotto.prezzo = itm.appoggio.prodotto.prezzo.L1.base || 0
        itm.appoggio.anagrafica = (itm.anagrafica.cliente && itm.anagrafica.cliente.codice) || (itm.anagrafica.fornitore && itm.anagrafica.fornitore.codice) 
      },
      duplicateItem(item) {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, item)
        this.editedItem._id = ''
        delete this.editedItem._rev
        this.$store.commit('movimenti/SET_MOVIMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      deleteItem (item) {
        this.editedIndex = this.movimenti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      async deleteItemConfirm () {
        this.movimenti.splice(this.editedIndex, 1)
        // TODO: ATTENZIONE VA VERIFICATO CHE NON ABBIA STORIA
        if (!await movimenti.cancellaMovimento(this.editedItem.movimento.id)) {
          this.dialogErrore = true
        }
        if (!await prodotti.aggiornaDeltaGiacenza(
            this.editedItem.items.prodotto._id,
            this.editedItem.items.movimento.magazzino,
            -this.editedItem.items.movimento.quantita
          )
        ) {
          this.dialogErrore = true
        }
        this.closeDelete()
        this.editedIndex = -1
        this.editedItem = Object.assign({}, null)        
      },

      close () {
        this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, null)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, null)
          this.editedIndex = -1
        })
      },
      async save () {
        this.$store.commit('movimenti/CLEAR_MOVIMENTO_SAVED')
        this.editedItem = this.$store.getters['movimenti/movimento']
        let modificaNominativo = false
        if (this.editedIndex > -1) {
          const itm = this.editedItem
          const newAnagrafica = (itm.anagrafica.cliente && itm.anagrafica.cliente.codice) || (itm.anagrafica.fornitore && itm.anagrafica.fornitore.codice)
          const oldAnagrafica = this.editedItem.appoggio.anagrafica
          if (newAnagrafica != oldAnagrafica) {
            modificaNominativo = true
          }
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)        
          Object.assign(this.movimenti[this.editedIndex], this.editedItem)
          if (!await movimenti.aggiornaMovimento(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        } else {
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)
          this.movimenti.push(this.editedItem)
          if (!await magazzino.creaMovimenti(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        }
        this.close()
        this.$store.commit('movimenti/CLEAR_MOVIMENTO')
        if (modificaNominativo) {
          this.$store.commit('movimenti/SET_GOTO_BASE')
          this.$store.commit('movimenti/SET_REFRESH', 'testata')
        } else {
          // va fatto il refresh della lista per prendere gli aggiornamenti
          await this.getDataFromApi()
        }
      },      
      erroreConfirm() {
        this.dialogErrore = false
        this.erroreMovimento = ''
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
        const item = options.item
        this.editedIndex = this.movimenti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('movimenti/SET_MOVIMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', true)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      datiVisualizzazione(movimenti) {
        const elaborati = movimenti.map(el => {
         // const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)
          const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.codice) || (el.anagrafica.cliente && el.anagrafica.cliente.codice)
          return { ...el, c_nominativo: nominativo }
        }) 
        return elaborati
      },
      deleteDatiVisualizzazione(movimento) {
        let locMovimento = {...movimento}
        delete locMovimento.c_nominativo
        delete locMovimento.appoggio
        return locMovimento
      },
      async onSpeedDialogComando(comando, payload) {
        switch (comando) {
/*           case 'stampa-etichette__':
            const impostazioni = await configurazioni.getConfigurazione('display_generale', 'etichette')
            this.tipoStampa = impostazioni.tipo
            this.report = impostazioni.report
            this.isModuloA4 = impostazioni.tipo === 'pdf'
            this.dialogStampa = true
            break */
          case 'stampa-etichette':
            this.$refs.stampaEtichette.stampaEtichette(this.elencoEtichette(), 'movimenti')
            this.annullaSelezione()
          default:
            break
        }
      },
	    elencoEtichette() {
        const etichette = this.selected.map(el => {
          return {
            id: el.movimento.id,
            quantita: this.usaQtaAnagrafica ? 1 : el.quantita,
            idpr: el.prodotto.id
          }
        })
        return etichette
      },
 /*      onDialogCancel() {
        this.dialogStampa = false
      },
      async onDialogPrint(usaQtaAnagrafica, salta) {
        this.usaQtaAnagrafica = usaQtaAnagrafica
        this.salta = salta
        this.dialogStampa = false
        const etichette = this.selected.map(el => {
          return {
            id: el.movimento.id,
            codice: el.prodotto.codice,
            descrizione: el.prodotto.descrizione,
            taglia: el.prodotto.variante1.codice,
            colore: el.prodotto.variante2.codice,
            prezzo: el.prodotto.prezzo,
            acquisto: el.prodotto.acquisto,
            barcode: el.prodotto.barcode,
            prezzo2: el.prodotto.prezzo2,
            quantita: this.usaQtaAnagrafica ? 1 : el.quantita
          }
        })
        await this.stampaEtichette(etichette)
      },
      async stampaEtichette(etichette) {
        try {
          // let selezionati = movimentiSelezionati
          const tipoQuantita = this.usaQtaAnagrafica ? 'anagrafica' : 'movimento'
          // const impostazioni = await configurazioni.getConfigurazione('display_generale', 'etichette')
          // const str = JSON.stringify(etichette)

          await etichetteService.stampaEtichetta(this.tipoStampa, this.report, etichette, this.salta, tipoQuantita)
        } catch {
        }
        this.annullaSelezione()
      }, */
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
    td.articoliSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
